import { AumChart, aumDistributionChart } from '../redux-store/types/api-types';

export function filteringAum(array: Array<AumChart>) {
    // console.log('array', array)

    const filterArray = [...array].sort((a, b) => Number(b.netAssets) - Number(a.netAssets)).filter((item: AumChart) => Number(item.netAssets) > 0)

    const familyName: Array<string> = [];
    const individual: Array<string> = [];

    [...filterArray]?.reduce((prev = [], curr: AumChart): any => {
        if (curr.customer && !individual.includes(curr.customer)) {
            individual.push(curr.customer);
        }

        if (curr.familyId && !familyName.includes(curr.familyId)) {
            familyName.push(curr.familyId);
        }
        return prev;
    }, []);


    // aum chart Family
    const AumFamilyName: Array<string> = [];
    const AumFamilyValue: Array<number> = [];
    familyName.filter((item) => item !== "Not Applicable").forEach((item: string, index) => {
        const individualAssetValue = filterArray.reduce((prev: any, curr: AumChart): any => {
            if (curr.familyId === item) {
                return prev + (Number(curr?.netAssets) ?? 0);
            } else {
                return prev;
            }
        }, 0);

        const currentFamilyObj = filterArray.find(obj => obj.familyId === item)

        AumFamilyName.push(currentFamilyObj?.familyName ?? "");
        AumFamilyValue.push(individualAssetValue);
    });

    // aum chart individual
    const AumIndividualName: Array<string> = [];
    const AumIndividualValue: Array<number> = [];

    // individual.map((item, i) => {
    //     const findIndex = filterArray.findIndex((obj: AumChart) => obj.customer === item);
    //     console.log('findIndex', findIndex)

    //     AumIndividualName.push(filterArray[findIndex]?.customerName);
    //     AumIndividualValue.push(Number(filterArray[findIndex]?.netAssets));
    //     return item
    // })

    // console.log('individual', individual)

    individual.filter((item) => item !== "Not Applicable").forEach((item: string, index) => {
        const individualAssetValue = filterArray.reduce((prev: any, curr: AumChart): any => {
            if (curr.customer === item) {
                return prev + (Number(curr?.netAssets) ?? 0);
            } else {
                return prev;
            }
        }, 0);

        const individualAssetName = filterArray.reduce((prev: any, curr: AumChart): any => {
            if (curr.customer === item) {
                return curr.customerName;
            } else {
                return prev;
            }
        }, 0);

        AumIndividualName.push(individualAssetName);
        AumIndividualValue.push(individualAssetValue);
    });



    return {
        aum: {
            family: {
                name: AumFamilyName.length > 5 ? [...AumFamilyName.slice(0, 5)] : [...AumFamilyName],
                value: AumFamilyValue.length > 5 ? [...AumFamilyValue.slice(0, 5)] : [...AumFamilyValue],
            },
            individual: {
                name: AumIndividualName.length > 5 ? [...AumIndividualName.slice(0, 5), "Others"] : [...AumIndividualName],
                value: AumIndividualValue.length > 5 ? [...AumIndividualValue.slice(0, 5)] : [...AumIndividualValue],
            },
        },
        filterOption: [
            {
                label: 'By Individual',
                value: 1,
            },
            {
                label: 'By Family',
                value: 2,
            },
        ],
    };
}
